import { Component, Inject, Input, OnInit } from '@angular/core';
import {
    faAngleDoubleDown,
    faAngleDoubleUp,
    faBuilding,
    faChevronDown,
    faChevronUp,
    faInfoCircle,
    faLongArrowAltUp,
    faTaxi,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';
import {
    AppNotificationService,
    AppNotificationType,
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigConstants,
    ConfigService,
    MaterialModel,
    ModalClass,
} from '@evorait/pace-core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { MaterialReturnP58Component } from '../../material-return-p58/material-return-p58.component';
import MaterialReturnP58Model from '../../material-return-p58/material-return-p58.model';

@Component({
    selector: 'pace-material-history-detail',
    templateUrl: './material-history-detail.component.html',
    styleUrls: ['./material-history-detail.component.scss'],
})
export class MaterialHistoryDetailComponent implements OnInit {
    @Input() public material: MaterialModel;

    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public isCollapsed = true;
    public readonly customerAddress = ConfigConstants.returnCustomer;
    public readonly dopAddress = ConfigConstants.returnDop;
    public readonly taxiAddress = ConfigConstants.returnTaxi;
    public readonly HIGH = 'HIGH';
    public readonly MEDIUM = 'MEDIUM';
    public readonly LOW = 'LOW';
    public faUsers = faUsers;
    public faBuilding = faBuilding;
    public faTaxi = faTaxi;
    public faAngleDoubleDown = faAngleDoubleDown;
    public faAngleDoubleUp = faAngleDoubleUp;
    public faLongArrowAltUp = faLongArrowAltUp;
    public faInfoCircle = faInfoCircle;
    public displayAdditionalMaterialRequestInformation = false;
    public showAwbReturn = false;
    public showStatusString = false;
    public showStatusStringButton = false;
    public constructor(
        private readonly modalService: BsModalService,
        private readonly appNotificationService: AppNotificationService,
        private readonly translate: TranslateService,
        private readonly configService: ConfigService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {}

    public ngOnInit(): void {
        this.displayAdditionalMaterialRequestInformation =
            this.configService.getDisplayAdditionalMaterialRequestInformation();

        /* checks if awb return need to be displayed instead of Status string
         * value based on the material if already Returned.*/
        this.showAwbReturn =
            this.clientManager.isNgmP58() && this.material.materialStatus && this.material.materialStatus.isReturned;

        /* checks if only Status string need to be displayed */
        this.showStatusString =
            (this.material.materialStatus &&
                !this.material.materialStatus.isReturn &&
                !this.material.materialStatus.isReturned) ||
            (this.clientManager.isNgmAP0() && this.material.materialStatus.isReturned) ||
            this.material.materialStatus.isNoPhysicalReturn;

        /* checks if Status string Button need to be displayed */
        this.showStatusStringButton = this.material.materialStatus && this.material.materialStatus.isReturn;
    }

    public openInfoText(event: Event, infoText: string): void {
        event.stopPropagation();
        this.appNotificationService.setAppNotification(
            AppNotificationType.INFO,
            <string>this.translate.instant('DASHBOARD_SIDEMENU_MATERIAL_HISTORY_STATUS_INFO_TEXT'),
            infoText,
        );
    }

    public openMaterialReturn(): void {
        this.modalService.show(MaterialReturnP58Component, {
            backdrop: 'static',
            class: ModalClass.MODAL_LARGE,
            initialState: {
                model: new MaterialReturnP58Model(),
            },
            ariaLabelledBy: 'material-return-p58-modal-title',
        });
    }
}
